/**
 * Created by Astha on 12/2/2018.
 */
import {
  FlexDeleteCommandArgs,
  FlexDeleteQuery,
  FlexZoomCommandResponse,
  RepoItem
} from "../../../autogenerated/ZoomBridge";
import _ from "lodash";
import SaveSettings from "../../settings/SaveSettings";
//@flow
export class FlexDelete {
  _assetArray: Array<RepoItem>;

  constructor(assetArray: Array<RepoItem>) {
    this._assetArray = assetArray;
  }

  run(): Promise<FlexZoomCommandResponse> {
    const query: FlexDeleteQuery = new FlexDeleteQuery();
    const deleteMessage: FlexDeleteCommandArgs = new FlexDeleteCommandArgs();
    deleteMessage.setLogMsg('Deleting file at server.');
    deleteMessage.setBranch(ThumbnailUtil.HEAD_BRANCH);
    deleteMessage.setIncludeSmartShare(SaveSettings.getBoolean(SaveSettings.SMART_LINK_INCLUDE_IN_DELETE));
    const remotePaths = this.getInFiles();
    deleteMessage.setInfiles(remotePaths);
    query.message = deleteMessage;
    return query.run();
  }

  getInFiles() {
    const remotePaths = [];
    _.map(this._assetArray, (asset) => remotePaths.push(asset.getRemotePath()));
    return remotePaths;
  }
}
